import React from "react";
import { Radio, RadioGroup, FormControlLabel, FormControl } from "@mui/material";
import "./components.css";

export default function RadioComponent(props) {
  const { value, onChange, options, questionKey } = props;

  const handleAnswerChange = (event) => {
    onChange(questionKey, event.target.value);
  };

  return (
    <FormControl 
    component="fieldset" 
    className="radio-group"
    sx={{
      width: '100%',
      '@media (min-width:600px)': {
        width: '50%'
      }
    }}
  >
    <RadioGroup value={value} onChange={handleAnswerChange}>
      {options.map((option, index) => (
        <FormControlLabel
          key={index}
          value={option.value}
          control={<Radio sx={{ '&.Mui-checked': { color: '#00634a' } }} />}
          label={option.text}
          className="radio-label"
        />
      ))}
    </RadioGroup>
  </FormControl>
  
  );
}
